import { Box, Button, DialogActions, Modal, Stack, TextField, Typography } from '@mui/material'
import type React from 'react'
import { useContext, useEffect, useRef, useState } from 'react'
import { inputSchema } from '../schema/inputSchema'
import { LanguageContext } from '../util/LanguageContext'

type ModalAddDialogProps = {
  open: boolean
  title: string
  onClose: () => void
  onSave: (value: string) => void
}

export const ModalAddDialog: React.FC<ModalAddDialogProps> = props => {
  const { open, title, onClose, onSave } = props
  const [isOpen, setIsOpen] = useState(open)
  const [inputValue, setInputValue] = useState('')
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [errorMessage, setErrorMessage] = useState('')
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const validate = async (value: string) => {
    try {
      await inputSchema.validate(value)
      setErrorMessage('')
      setIsButtonDisabled(false)
    } catch (err: any) {
      setErrorMessage(err.message)
      setIsButtonDisabled(true)
    }
  }
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
    validate(event.target.value)
  }

  const handleSave = () => {
    onSave(inputValue)
    onClose()
    setIsOpen(false)
  }
  const handleClose = (event: React.MouseEvent<HTMLInputElement>, reason: 'backdropClick') => {
    if (reason === 'backdropClick') return
    onClose()
    setIsOpen(false)
  }
  useEffect(() => {
    setIsButtonDisabled(inputValue === '')
  }, [inputValue])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '332px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '640px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: '0px 2px 2px #00000014',
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Typography
            sx={{
              mt: '48px',
              font: 'normal normal bold 32px/48px BIZ UDGothic',
              textAlign: 'center',
            }}
          >
            {translation['button_create_new']}
          </Typography>
          <Typography
            sx={{
              mt: '18px',
              color: '#282828',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              textAlign: 'center',
              mr: '50px',
              ml: '50px',
            }}
          >
            {`${translation['label_input_xxxxx_word']}`.replace('{title}', title || '')}
          </Typography>
          <TextField
            label=""
            value={inputValue}
            error={!!errorMessage}
            helperText={errorMessage ? translation[errorMessage] : ' '}
            inputRef={inputRef}
            onChange={handleInputChange}
            InputProps={{
              sx: {
                font: 'normal normal normal 21px/34px BIZ UDPGothic',
                borderRadius: '10px',
                height: '72px',
                width: '480px',
                pl: '8px',
                background: '#F4F4F4',
              },
            }}
            sx={{
              mt: '74px',
              '& .MuiOutlinedInput-root': {
                // "& fieldset": {
                //   borderColor: "white",
                // },
                // "&:hover fieldset": {
                //   borderColor: "white",
                // },
                '&.Mui-focused fieldset': {
                  borderColor: errorMessage ? 'red' : '#282828',
                },
              },
            }}
            // focused
          />
          <DialogActions sx={{ mt: '60px', mb: '60px' }}>
            <Button
              onClick={onClose}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: '#282828',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                border: '2px solid #282828',
                borderRadius: '10px',
                mt: '5px',
                mr: '30px',
                '&:hover': {
                  background: '#FFFFFF',
                  opacity: 0.8,
                },
              }}
            >
              {translation['button_cancel']}
            </Button>
            <Button
              type="submit"
              disabled={isButtonDisabled}
              onClick={handleSave}
              sx={{
                height: '49px',
                width: '181px',
                font: 'normal normal bold 21px/29px Noto Sans JP',
                color: isButtonDisabled ? '#CACACA' : '#FFFFFF',
                background: isButtonDisabled ? '#F4F4F4 0% 0% no-repeat padding-box' : '#282828',
                borderRadius: '10px',
                mt: '5px',
                '&:hover': {
                  backgroundColor: '#282828',
                  opacity: 0.8,
                  boxShadow: 0,
                },
              }}
            >
              {translation['button_create']}
            </Button>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}
